import { render, staticRenderFns } from "./RequisitionDetailPage.vue?vue&type=template&id=fbec5eee&"
import script from "./RequisitionDetailPage.vue?vue&type=script&lang=ts&"
export * from "./RequisitionDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./RequisitionDetailPage.vue?vue&type=style&index=0&id=fbec5eee&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports